<div class="d-flex flex-column" [class.landing]="isLanding">
  <div class="page-background">
    @if(isLanding){
      <div class="landing-gradient-box">
      </div>
    }
    @if(showHeader){
        <app-page-header [isLanding]="isLanding"/>
    }
    <div [class.padding-top-navbar]="!isLanding" class="position-relative">
      <ng-content></ng-content>
    </div>
  </div>
</div>
